import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import {
  PaymentOrderInfoRoot,
  PaymentOrderInfoBlockquote,
  PaymentOrderInfoTitle,
  PaymentOrderInfoDescription
} from './PaymentOrderInfo.style';

const MESSAGE_IDS = {
  title: 'dashboard.klarnaLanding.paymentOrderInfo.title',
  description: 'dashboard.klarnaLanding.paymentOrderInfo.description'
};

function PaymentOrderInfo() {
  return (
    <PaymentOrderInfoRoot>
      <PaymentOrderInfoBlockquote>
        <PaymentOrderInfoTitle>
          <FormattedMessage id={MESSAGE_IDS.title} />
        </PaymentOrderInfoTitle>
        <PaymentOrderInfoDescription>
          <FormattedMessage id={MESSAGE_IDS.description} />
        </PaymentOrderInfoDescription>
      </PaymentOrderInfoBlockquote>
    </PaymentOrderInfoRoot>
  );
}

export default PaymentOrderInfo;
